import { render, staticRenderFns } from "./update-registration.vue?vue&type=template&id=784cccb8&scoped=true&"
import script from "./update-registration.vue?vue&type=script&lang=js&"
export * from "./update-registration.vue?vue&type=script&lang=js&"
import style0 from "./update-registration.vue?vue&type=style&index=0&id=784cccb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784cccb8",
  null
  
)

export default component.exports